import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { MatRadioModule } from '@angular/material/radio';
import { UiRadioWrappedDirective } from '@ui';

interface TaskWhenOption {
  value: string;
  label: string;
  description: string;
}

@Component({
  selector: 'sbnb-add-task-rule-flow-manual-task-when',
  standalone: true,
  imports: [CommonModule, MatRadioModule, UiRadioWrappedDirective],
  templateUrl: './add-task-rule-flow-manual-task-when.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddTaskRuleFlowManualTaskWhenComponent {
  taskType = input.required<string>();
  selectedWhen = signal<string | null>(null);
  whenSelected = output<string>();

  readonly checkoutOptions: TaskWhenOption[] = [
    {
      value: 'before-checkout',
      label: 'Before check-out',
      description: 'Tasks will be created before the guest checks out.',
    },
    {
      value: 'after-checkout',
      label: 'After check-out',
      description: 'Tasks will be created after the guest checks out.',
    },
  ];

  readonly maintenanceOptions: TaskWhenOption[] = [
    {
      value: 'recurring',
      label: 'Recurring',
      description: 'Tasks will be created on a recurring schedule.',
    },
    {
      value: 'before-checkin',
      label: 'Before check-in',
      description: 'Tasks will be created before the guest checks in.',
    },
    {
      value: 'after-checkin',
      label: 'After check-in',
      description: 'Tasks will be created after the guest checks in.',
    },
    {
      value: 'before-checkout',
      label: 'Before check-out',
      description: 'Tasks will be created before the guest checks out.',
    },
    {
      value: 'after-checkout',
      label: 'After check-out',
      description: 'Tasks will be created after the guest checks out.',
    },
  ];

  get options(): TaskWhenOption[] {
    return this.taskType() === 'checkout' ? this.checkoutOptions : this.maintenanceOptions;
  }

  onWhenChange(value: string): void {
    this.selectedWhen.set(value);
    this.whenSelected.emit(value);
  }
}
